import { render } from "./SeolqiChairV3.vue?vue&type=template&id=4a426030&scoped=true"
import script from "./SeolqiChairV3.vue?vue&type=script&lang=js"
export * from "./SeolqiChairV3.vue?vue&type=script&lang=js"

import "./SeolqiChairV3.vue?vue&type=style&index=0&id=4a426030&scoped=true&lang=css"
import "./SeolqiChairV3.vue?vue&type=style&index=1&id=4a426030&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a426030"]])

export default __exports__